import React from 'react';
import styles from './SidebarMenu.module.scss';
import { cls } from '../View/utils';
import SidebarItem from './SidebarItem';
import { Grouping } from '@yleisradio/areena-types';
import { SidebarColumn } from './types';
import { getTranslation } from '../localizations/translations';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';

const classNames = {
  sidebarIconGroup: 'sidebarIconGroup',
  sidebarNonIconGroup: 'sidebarNonIconGroup',
  mainIconMenuGroup: 'mainIconMenuGroup',
};

type Props = {
  toggleOpenSidebar: () => void;
  groupings: Grouping[];
};

export const SidebarMenu: React.FC<Props> = ({
  groupings,
  toggleOpenSidebar,
}) => {
  const { languageCode } = useAppFeaturesContext();
  return (
    <nav
      className={styles.sidebarMenu}
      onClick={toggleOpenSidebar}
      data-testid="sidebar-menu"
      role={'menu'}
      aria-label={getTranslation('common_menu', languageCode)}
    >
      {groupings?.map((grouping, index, all) => {
        const groupClassName = cls({
          [styles.sidebarMenuGroup]: true,
          [classNames.mainIconMenuGroup]: index === 1,
          [classNames.sidebarIconGroup]: grouping.controls.some(
            control =>
              !!control.icon || control?.functionality?.id === 'profile'
          ),
          [classNames.sidebarNonIconGroup]: grouping.controls.some(
            control => !control.icon && control?.functionality?.id !== 'profile'
          ),
        });

        const controlsBefore = all
          .slice(0, index)
          .reduce((count, group) => count + group.controls.length, 0);

        return (
          <div className={groupClassName} key={index}>
            {grouping.controls.map((control, controlIndex) => (
              <SidebarItem
                control={control}
                key={control.title}
                id={`0/${SidebarColumn.Menu}/${controlsBefore + controlIndex}`}
              />
            ))}
          </div>
        );
      })}
    </nav>
  );
};
